import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import SubCard from 'src/components/cards/SubCard';
import { Box, Button } from '@mui/material';
import NavigationIcon from '@mui/icons-material/Navigation';




function ServiceLocation({ ServiceShopId, ServiceShopFullName, ServiceShopAddress }) {
    const [serviceLatitude, setServiceLatitude] = React.useState(0);
    const [serviceLongitude, setServiceLongitude] = React.useState(0);

    const MapComponent = () => {
        useEffect(() => {
            const script = document.createElement('script');
            script.src = "https://www.locationbox.com.tr/locationbox/services?Key=2530000206000119004900080902010X20621090010050210009069&Cmd=API&Typ=JS";
            script.language = "Javascript";
            script.async = true;

            document.body.appendChild(script);

            script.onload = () => {
                window.alert = function () { };
                const mapper = new window.IMapper();
                axios.get(`https://www.locationbox.com.tr/locationbox/services?Key=2530000206000119004900080902010X20621090010050210009069&Cmd=Geocode&Typ=output_format&Address=${ServiceShopAddress}`)
                    .then(response => {
                        if (response.data) {
                            const longitude = response.data.geocode.longitude;
                            const latitude = response.data.geocode.latitude;
                            setServiceLatitude(latitude);
                            setServiceLongitude(longitude);
                            mapper.initMap(latitude, longitude, 16, mapper.BASEMAP_TILELAYER_NOLOGO, 'https://www.locationbox.com.tr/mapviewer');
                            mapper.addNavigationPanel();
                            mapper.addMarker('1', latitude, longitude, 'ServiceShopFullName', 'M.LB_MARKER_OUTSIDE_RED', 50, 80);
                            //mapper.addCustomMarker('1', latitude, longitude, 'ServiceShopFullName', 'images/arcelik-map-pin.png', null);
                            //mapper.zoomToMarkers("1");
                        }
                    }).catch(error => {
                    });

            };

            return () => {
                document.body.removeChild(script);
            };
        }, []);

        return (
            <div id="map" style={{ border: '1px solid black', width: '100%', height: '100%', zIndex: 0 }}>
            </div>
        );
    }




    return (
        <SubCard title={ServiceShopFullName} style={{ height: '100%' }}>
            <Box sx={{ position: 'relative', height: '100%' }}>
                <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<NavigationIcon />}
                    onClick={() => window.open(`https://google.com/maps?q=${serviceLatitude},${serviceLongitude}&z=15`, '_blank')}
                    style={{ position: 'absolute', zIndex: 1, right: 10, top: 10 }}
                >

                    Harita Uygulamasına Git
                </Button>
                <div style={{ margin: 0, padding: 0, height: '94vh', width: '94vw' }}>
                    <Helmet>
                        <script
                            language="Javascript"
                            src="https://www.locationbox.com.tr/locationbox/services?Key=2530000206000119004900080902010X20621090010050210009069&Cmd=API&Typ=JS"
                            async
                        />
                    </Helmet>
                    <MapComponent />
                </div>
            </Box>
        </SubCard>
    );
}

export default ServiceLocation;
